const main = resolve => require(['@/views/index/index.vue'], resolve) // 主页
const logisticsManage = resolve =>
  require(['@/views/logisticsManage/index.vue'], resolve) // 物流管理

export default [
  {
    path: '/index',
    component: main,
    children: [
      // 物流管理
      {
        name: 'LogisticsManage',
        path: '/aq/logisticsManage',
        alias: ['/aq/logisticsManage.htm'],
        component: logisticsManage
      }
    ]
  }
]
